import React, { useEffect } from 'react';
import './PrivacyModal.css';

const PrivacyModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Privacy Policy</h2>
        <div className="modal-body">
          <p>
            Welcome to Softblitz Resources Inc. We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
          </p>
          <h4>1. Information We Collect</h4>
          <p>
            We may collect personal information from you such as your name, email address, and message content when you voluntarily provide it to us through our contact form. We do not collect any personal information automatically.
          </p>
          <h4>2. Use of Your Information</h4>
          <p>
            Having accurate information permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:
          </p>
          <ul>
            <li>Respond to your comments, inquiries, and provide customer service.</li>
            <li>Email you regarding your inquiry.</li>
            <li>Increase the efficiency and operation of the Site.</li>
          </ul>
          <h4>3. Disclosure of Your Information</h4>
          <p>
            We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information. This does not include trusted third parties who assist us in operating our website, so long as those parties agree to keep this information confidential. We may also release your information when we believe release is appropriate to comply with the law.
          </p>
          <h4>4. Security of Your Information</h4>
          <p>
            We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
          </p>
          <h4>5. Contact Us</h4>
          <p>
            If you have questions or comments about this Privacy Policy, please contact us at info@softblitzresources.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;